<template>
    <div class="relative flex flex-col h-screen">
        <img :src="getImage('mascot')" class="fixed papsi-mascot">

        <div class="flex flex-1 lg:flex-row flex-col">
            <SidebarSection>
                <LabelControl type="message" :content="$t('has006')" />
            </SidebarSection>

            <ContentSection @logout="logout">
                <div class="bg-grey-lighter pt-10 pl-10 rounded-lg papsi-container">
                    <LabelControl type="heading" :content="$t('has003')" />

                    <div class="mt-10 overflow-y-auto text-justify papsi-text">
                        <div class="text-grey-darkest leading-normal text-2xl pr-10 pb-32" style="line-height: 50px;">
                            <div class="mb-12">
                                PAFCPIC Interactive Assistant (PIA) is licensed to You (End-User) by Philippine Army
                                Finance Center Producers Integrated Cooperative (PAFCPIC), located and registered at
                                PAFCPIC Bldg., Bayani Road, Taguig, Metro Manila 1634, Philippines ("Licensor"), for use
                                only under the terms of this License Agreement
                                <br>
                                <br>
                                The parties of this License Agreement acknowledge that the Services are not a Party to
                                this License Agreement and are not bound by any provisions or obligations with regard to
                                the Licensed Application, such as warranty, liability, maintenance and support thereof.
                                PAFCPIC, not the Services, is solely responsible for the Licensed Application and the
                                content thereof.
                                <br>
                                <br>
                                PAFCPIC acknowledges that it had the opportunity to review the Usage Rules and this
                                License Agreement is not conflicting with them.
                                <br>
                                <br>
                                PIA, when purchased or downloaded through the Services, is licensed to You for use only
                                under the terms of this License Agreement.
                            </div>

                            <div class="mb-12">
                                <b class="uppercase">Table of Contents</b>
                                <ol>
                                    <li>THE APPLICATION</li>
                                    <li>SCOPE AND LICENSE</li>
                                    <li>TECHNICAL REQUIREMENTS</li>
                                    <li>MAINTENANCE AND SUPPORT</li>
                                    <li>USE OF DATA</li>
                                    <li>LIABILITY</li>
                                    <li>WARRANTY</li>
                                    <li>PRODUCT CLAIMS</li>
                                    <li>CONTACT INFORMATION</li>
                                    <li>TERMINATION</li>
                                    <li>THIRD-PARTY TERMS OF AGREEMENT & BENEFICIARY</li>
                                    <li>INTELLECTUAL PROPERTY RIGHTS</li>
                                    <li>APPLICABLE LAW</li>
                                    <li>MISCELLANEOUS</li>
                                </ol>
                            </div>

                            <div class="mb-12">
                                <b class="uppercase">1. APPLICATION</b>
                                <p>
                                    PIA ("Licensed Application") is a digital kiosk software designed to provide users with convenient access to their membership details, transaction history, and balances.
                                </p>
                            </div>

                            <div class="mb-12">
                                <b class="uppercase">2. SCOPE OF LICENSE</b>
                                <p>2.1 The application usage is exclusive only to a membership applicant. There should
                                    be no sharing to members of the family or even to volume purchasing which finds no
                                    application in online membership application.</p>
                                <p>2.2 This license will also govern any updates of the Licensed Application provided by
                                    Licensor that replace, repair, and/or supplement the first Licensed Application,
                                    unless a separate license Is provided for such update, in which case the terms or
                                    that new license will govern.
                                </p>
                                <p>2.3 You may not share or make the Licensed Application available to third parties.
                                </p>
                                <p>2.4 You may not reverse engineer, translate, disassemble, integrate, decompile,
                                    remove modify, combine, create derivative works or updates of, adapt, or attempt to
                                    derive the source.
                                </p>
                                <p>2.5 You may not copy (excluding when expressly authorized by this license and the
                                    Usage Rules) or alter the Licensed Application or portions thereof. You may create
                                    and store copies only on devices that You own or control for backup keeping under
                                    terms of this license, the Usage Rules, and any other terms and conditions that
                                    apply to the device or software used. You may not remove any intellectual property
                                    notices. You acknowledge that no unauthorized third parties may gain access to these
                                    copies at any time. If you sell your Devices to a third party, you must remove the
                                    Licensed Application from the Devices before doing so.
                                </p>
                                <p>2.6 Violations of the obligations mentioned above, as well as the attempt of such
                                    infringement, may be subject to prosecution and damages and termination of
                                    membership.
                                </p>
                                <p>2.7 Licensor reserves the right to modify the terms and conditions of licensing.
                                </p>
                                <p>2.8 Nothing in this license should be interpreted to restrict third-party terms. When
                                    using the Licensed Application, You must ensure that You comply with applicable
                                    third-party terms and conditions
                                </p>
                            </div>

                            <div class="mb-12">
                                <b class="uppercase">3. TECHNICAL REQUIREMENTS</b>
                                <p>3.1 Licensor attempts to keep the Licensed Application updated so that it complies with modified/new versions of the firmware and new hardware. You are not granted rights to claim such an update.
                                </p>
                                <p>3.2 You acknowledge that it is Your responsibility to confirm and determine that the app end- user device on which You intend to use the Licensed Application satisfies the technical specifications mentioned above.
                                </p>
                                <p>3.3 Licensor reserves the right to modify the technical specifications as it sees appropriate at any time.
                                </p>
                            </div>

                            <div class="mb-12">
                                <b>4. MAINTENANCE AND SUPPORT</b>
                                <p>4.1 The Licensor is solely responsible for providing any maintenance and support services for this Licensed Application. You can reach the Licensor at the email address provided at Section 9 of this License Agreement.
                                </p>
                                <p>4.2 PAFCPIC and the End-user acknowledge that the Services have no obligation whatsoever to furnish any maintenance and support services with respect to the Licensed Application.
                                </p>
                            </div>

                            <div class="mb-12">
                                <b>5. USE OF DATA
                                </b>
                                <p>You acknowledge that Licensor will be able to access and adjust your downloaded Licensed Application content and your personal information, and that Licensor's use of such material and information is subject to Your legal agreements with Licensor and Licensor's privacy policy. (Data Privacy Policy link)
                                </p>
                                <p>You acknowledge that the Licensor may periodically collect and use technical data and related information about your device, system, and application software, and peripherals, offer product support, facilitate the software updates, and for purposes of providing other services to you (if any) related to the Licensed Application. Licensor may also use this information to improve its products or to provide services or technologies to you, as long as it is in a form that does not personally identify you.
                                </p>
                                <p>Any use of the Licensed Application in violation of the foregoing violates this License Agreement and may result in, among other things, possible termination of membership, termination or suspension of your rights to use the Licensed Application.
                                </p>
                            </div>

                            <div class="mb-12">
                                <b>6. LIABILITY
                                </b>
                                <p>Licensor takes no accountability or responsibility for any damages caused due to a breach of duties according to Section 2 of this License Agreement. To avoid data loss, you are required to make use of backup functions of the Licensed Application to the extent allowed by applicable third-party terms and conditions of use. You are aware that in case of alterations or manipulations of the Licensed Application, You will not have access to the Licensed Application.
                                </p>
                            </div>

                            <div class="mb-12">
                                <b>7. WARRANTY
                                </b>
                                <p>7.1 Licensor warrants that the Licensed Application is free of spyware, trojan horses, viruses, or any other malware at the time of Your download. Licensor warrants that the licensed Application works as described in the user documentation.
                                </p>
                                <p>7.2 No warrant is provided for the Licensed Application that is not executed on the end-user's device, that has been unauthorizedly modified, handled inappropriately or culpably, combined or installed with inappropriate hardware or software, used with inappropriate hardware or software, used with inappropriate accessories, regardless if by Yourself or by third parties, or if there are any other reasons outside of PAFCPIC's sphere of influence that affect the executability of the Licensed Application.</p>
                                <p>7.3 You are required to inspect the Licensed Application immediately after installing it and notify PAFCPIC about issues discovered without delay through email at customer@pafcpic365.com. The defect report will be taken into consideration and further investigated if it has been emailed within a period of thirty (30) days after discovery.
                                </p>
                                <p>7.4 If we confirm that the Licensed Application is defective, PAFCPIC shall rectify the defect and provide you with the corrected/revised/updated application the soonest time possible.
                                </p>
                            </div>

                            <div class="mb-12">
                                <b>8. PRODUCT CLAIMS
                                </b>
                                <p>PAFCPIC and the End-User acknowledge that PAFCPIC and not the Services, is responsible for addressing any claims of the End-User relating to the Licensed Application or the End-User's possession and/or use of that Licensed Application.
                                </p>
                            </div>

                            <div class="mb-12">
                                <b>9. CONTACT INFORMATION
                                </b>
                                <p>For general inquiries, complaints, questions or claims concerning the Licensed Application, please contact:
                                </p>
                                <p>Philippine Army Finance Center Producers Integrated Cooperative
                                </p>
                                <p>Marketing & Communications Section</p>
                                <p>PAFCPIC Bldg., Bayani Road</p>
                                <p>Taguig, Metro Manila 1634 Philippines</p>
                                <p>customer@pafcpic365.com
                                </p>
                            </div>

                            <div class="mb-12">
                                <b>10. TERMINATION</b>
                                <p>The license is valid until terminated by PAFCPIC or by You. Your rights under this license will terminate automatically and without notice PAFCPIC if You fail to adhere to any term(s) of this license. Upon License termination, You shall stop all use of the Licensed Application, and destroy all copies, full or partial, of the Licensed Application.
                                </p>
                            </div>

                            <div class="mb-12">
                                <b>11. THIRD-PARTY TERMS OF AGREEMENTS AND BENEFICIARY
                                </b>
                                <p>PAFCPIC represents and warrants that PAFCPIC will comply with applicable third-party terms of agreement when using Licensed Application. In Accordance with Section 9 of the "Instructions for Minimum Terms of Developer's End-User License Agreement," both Apple and Google and their subsidiaries shall be third-party beneficiaries of this End User License Agreement and - upon Your acceptance of the terms and conditions of this License Agreement, both Apple and Google will have the right (and will be deemed to have accepted the right) to enforce this End User License Agreement against You as a third-party beneficiary thereof.
                                </p>
                            </div>

                            <div class="mb-12">
                                <b>12. INTELLECTUAL PROPERTY RIGHTS</b>
                                <p>PAFCPIC and the End-User acknowledge that, in the event of any third-party claim that the Licensed Application or the End-User's possession and use of that Licensed Application infringes on the third party's intellectual property rights, PAFCPIC, and not the Services, will be solely responsible for the investigation, defense, settlement, and discharge or any such intellectual property infringement claims.
                                </p>
                            </div>

                            <div class="mb-12">
                                <b>13. APPLICABLE LAW
                                </b>
                                <p>This License Agreement is governed by the laws of the Philippines excluding its conflicts of law rules.</p>
                            </div>

                            <div class="mb-12">
                                <b>14. MISCELLANEOUS</b>
                                <p>14.1 If any of the terms of this agreement should be or become invalid, the validity of the remaining provisions shall not be affected. Invalid terms will be replaced by valid ones formulated in a way that will achieve the primary purpose.
                                </p>
                                <p>14.2 Collateral agreements, changes and amendments are only valid if laid down in writing. The preceding clause can only be waived in writing.
                                </p>
                                
                               
                            </div>


                        </div>
                    </div>

                </div>

            </ContentSection>
        </div>

        <FooterSection />
    </div>
</template>

<script>
import SidebarSection from '@/components/sections/SidebarSection.vue';
import ContentSection from '@/components/sections/ContentSection.vue';
import FooterSection from '@/components/sections/FooterSection.vue';
import mixin from '@/mixins/controls.js';
import LabelControl from '@/components/controls/LabelControl.vue';

export default {
    mixins: [mixin],
    components: {
        SidebarSection,
        ContentSection,
        FooterSection,
        LabelControl,
    },
    mounted() {
        this.$emit('checkauth');
    },
    methods: {
        logout() {
            this.$emit('logout');
        },
    },
};
</script>

<style scoped>
.papsi-mascot {
    bottom: 0;
    left: 0;
    width: 25rem;
}

.papsi-container {
    height: 45rem;
}

.papsi-text {
    height: 34rem;
}

</style>
